export default __webpack_public_path__ + "static/media/crm.ba08787a.png";